import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'insufficient-credits-dialog',
    templateUrl: './insufficient-credits-dialog.component.html',
    standalone: false
})
export class InsufficientCreditsDialogComponent {
    public isOrgAdminUser = false;
    public isFreeTrialAccount?: boolean = false;

    constructor(
    public dialogRef: MatDialogRef<InsufficientCreditsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.isOrgAdminUser = this.data.isOrgUser;
        this.isFreeTrialAccount = this.data.isFreeTrialAccount;
    }
}
